export default {
  required: (value) => {
    if (!value) {
      return 'Campo obrigatório.'
    } else { return true }
  },
  noCoding: (val) => {
    if (!val) {
      return true
    }
    const a = ['<', '/*', '>', ';', '|']
    if (a.some(el => val.toString().includes(el))) {
      return 'Por favor não insira código no formulário'
    } else {
      return true
    }
  },
  domainFormat: (val) => {
    if (!val) {
      return true
    }
    if (val.match(/^(https?:\/\/)/)) {
      if (val.match(/\/+$/)) {
        return 'Por favor não insira uma barra no final do domínio'
      } else { return true }
    } else {
      return 'Por favor formate com https:// no começo'
    }
  },
  email: (val) => {
    if (!val) {
      return true
    }
    if (!val.includes('@') || !val.includes('.')) {
      return 'Por favor insira um e-mail válido'
    } else {
      return true
    }
  },
  min: (minLength) => {
    return v => {
      if (!v) return false || `Mínimo de ${minLength} caracteres`
      return v.length >= minLength || `Mínimo de ${minLength} caracteres`
    }
  },
  password: (val) => {
    if (!val) {
      return true
    }
    const regExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}$/
    return regExp.test(val)
      ? true
      : 'A senha deve ter ao menos 8 caracteres, incluindo uma letra maiúscula, uma minúscula, um dígito e um caractere especial'
  },
}
